import { useState, useEffect } from "react";
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import "./EventElement.scss"

const EventElement = ({
    id,
    title,
    dateTo,
    dateFrom,
    style,
    fetchEventData,
    setReadOnly,
    selectedEvent,
    setSelectedEvent,
    setIsModalCard
}) => {



    return (
        <div
            className='event-item'
            style={style}
            onClick={(e) => {
                e.stopPropagation()
                fetchEventData(id)
                setSelectedEvent(id)
                setIsModalCard(true)
                setReadOnly(true)
            }}
        >
            <p>{dateFrom?.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })} - {dateTo.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })} {title}</p>
        </div>
    )
}

export { EventElement }